class SubmitLoginService {
  constructor(rest) {
    this.rest = rest;
  }

  request(username, password) {
    return this.rest({
      method: 'POST',
      path: '/api/customer-self-management/rest/customerSelfManagement/access/login',
      headers: {
        'x-login-version': 'v2'
      },
      entity: {
        username,
        password
      }
    });
  }
}

export default SubmitLoginService;



/** WEBPACK FOOTER **
 ** ./src/services/SubmitLoginService.js
 **/